import { Button, Icon, P, Stack } from '@fashionnovateam/nova-ui-toolkit';
import { DateFilterValue, getTitleCard } from '../DateFilter/DateFilterCard';
import { PageLoading } from '../PageLoading/PageLoading';
import { PaginatedSearchParams } from '../../Lib/Hooks/purchase-orders.hooks';

type EmptyPoPageProps = {
  params: PaginatedSearchParams;
  loading?: boolean;
  onCleanFilters: () => void;
};

const RenderMessage = (search?: string, dueDate?: DateFilterValue | null) => {
  if (search && dueDate)
    return `We couldn’t find any POs that match your search ’${search}’ within the due date range of ${getTitleCard(dueDate)}.`;
  if (search)
    return `We couldn’t find any POs that match your search ’${search}’.`;
  if (dueDate)
    return `We couldn’t find any POs within the due date range of ${getTitleCard(dueDate)}.`;
  return 'No Purchase Order found.';
};

export function EmptyAndLoadingPoPage({
  params,
  loading = false,
  onCleanFilters,
}: EmptyPoPageProps) {
  const { search } = params;
  const filterDates = params.filter?.due_date;

  if (loading) return <PageLoading />;
  return (
    <Stack
      direction="col"
      content="center"
      align="center"
      gap="md"
      className="h-full"
      data-testid="po-list-empty-state"
      data-loading="false"
    >
      <Icon.FileSearch variant="solid" className="text-4xl text-primary-700" />
      <Stack direction="col" gap="sm" align="center">
        <P size="lg" color="primary" weight="medium">
          {RenderMessage(search, filterDates)}
        </P>
        <P size="xsm" color="secondary" weight="normal">
          Try changing your filters or search to see more results.
        </P>
      </Stack>
      <Button size="sm" onClick={onCleanFilters} className="w-fit">
        Reset search
      </Button>
    </Stack>
  );
}
